// src/lib/config.ts
// Chat configuration - Environment-based settings for flexibility

export const CHAT_CONFIG = {
  HISTORY_LIMIT: parseInt(import.meta.env.VITE_CHAT_HISTORY_LIMIT || '300', 10),
  RENDER_LIMIT: parseInt(import.meta.env.VITE_CHAT_RENDER_LIMIT || '200', 10),
  PAGE_SIZE: parseInt(import.meta.env.VITE_CHAT_PAGE_SIZE || '50', 10),
  SEARCH_LIMIT: parseInt(import.meta.env.VITE_CHAT_SEARCH_LIMIT || '200', 10),
};

// Validation helper
export function validateChatConfig(): boolean {
  const configKeys = Object.keys(CHAT_CONFIG);
  const valid = configKeys.every(key => !isNaN(CHAT_CONFIG[key as keyof typeof CHAT_CONFIG]));
  
  if (!valid) {
    console.error('[ChatConfig] Invalid configuration detected:', CHAT_CONFIG);
  }
  
  return valid;
}

// Initialize and validate on import
if (import.meta.env.DEV) {
  validateChatConfig();
  console.debug('[ChatConfig] Loaded:', CHAT_CONFIG);
}
